import { useDatalayerStore } from "@/store/datalayer";
import { useMagasinStore } from "@/store/magasin";
import { usePanierStore } from "@/store/panier";
import apiDriveListe from "@/services/http/api-drive/client/listeDeCourse";
import { states } from "@/components/molecules/mixins/form.mixin";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done"

export const pageMonCompteMesListesDeCoursesProps = () => ({
  listesDeCourse: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  }
})

export const pageMonCompteMesListesDeCoursesEmits = () => ([
  "reload"
])

export const usePageMonCompteMesListesDeCourses = (props, context, supprimerRef, creerRef, ajouterRef) => {

  const app = useNuxtApp()
  const magasinStore = useMagasinStore()
  const datalayerStore = useDatalayerStore()
  const panierStore = usePanierStore()

  const { trackEvent } = useInteractionDoneTracking();

  const isLoading = ref(false)
  const listeSelected = ref(null)
  const listesSelected = ref([])
  const listesToDelete = ref([])
  const createListeError = ref(null)
  const createListeState = ref(null)

  const { id: magasinId, isNational } = storeToRefs(magasinStore);

  const { location } = storeToRefs(datalayerStore);

  const { setStoreLocatorContext } = datalayerStore;
  const { displayStoreLocator } = magasinStore;
  const { addListeDeCourseToPanier } = panierStore;

  const toggleSelectList = (value, liste) => {
    const isInArray = listesSelected.value.some(listeSelected => listeSelected.id === liste.id);
    if (value && !isInArray) {
      listesSelected.value.push(liste);
    } else if (isInArray) {
      listesSelected.value = listesSelected.value.filter(selectedList => selectedList.id !== liste.id);
    }
  }
  const isSelected = (id) => {
    return listesSelected.value.some(selectedList => selectedList.id === id);
  }
  const selectAll = () => {
    listesSelected.value = props.listesDeCourse;
  }
  const unselectAll = () => {
    listesSelected.value = [];
  }
  const deleteListes = () => {
    listesToDelete.value = listesSelected.value;
    supprimerRef.value.show();
  }
  const deleteListe = (liste) => {
    listesToDelete.value = [liste];
    supprimerRef.value.show();
  }
  const confirmDeleteListes = async () => {
    isLoading.value = true;
    try {
      for (let i = 0; i < listesToDelete.value.length; i++) {
        await app.$apiDrive.use(apiDriveListe).delete(listesToDelete.value[i].id);
      }
      listesSelected.value = listesSelected.value.filter(el => { return !listesToDelete.value.includes(el) });
      listesToDelete.value = [];
      supprimerRef.value.hide();
    } finally {
      context.emit("reload");
      isLoading.value = false;
    }
  }
  const openCreateListe = () => {
    createListeState.value = null;
    creerRef.value.show();
  }
  const createListe = async (titre) => {
    trackEvent(
      {
        actionGA: trackingCodes.ACTIONGA.createShoppingList,
        labelGA: location.value,
        categoryGA: trackingCodes.SHOPPINGLIST
      });
    createListeState.value = states.LOADING;
    try {
      const liste = await app.$apiDrive.use(apiDriveListe).create(
        magasinId.value,
        {
          titre,
          items: []
        }
      );
      createListeState.value = states.SUCCESS;
      isLoading.value = false;
      const needGoToDetail = props.listesDeCourse.length === 0;
      context.emit("reload");
      setTimeout(() => {
        if (creerRef.value && creerRef.value.hide) {
          creerRef.value.hide();
        }
        createListeState.value = null;
        if (needGoToDetail) {
          navigateToInternal(`/mon-compte/mes-listes-de-courses/${liste.data.id}`);
        }
      }, 5000);
    } catch (e) {
      createListeError.value = app.$apiDrive.getErrorData(e);
    } finally {
      isLoading.value = false;
    }
  }
  const addToCartListe = (liste) => {
    listeSelected.value = liste;
    ajouterRef.value.show();
  }
  const confirmAddToCartListe = async (liste) => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    trackEvent({
      actionGA: trackingCodes.ACTIONGA.cartAttachement,
      categoryGA: trackingCodes.SHOPPINGLIST,
      labelGA: ''
    });
    await addListeDeCourseToPanier(liste.id);
    ajouterRef.value.hide();
  }
  const addToCartListes = async () => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    isLoading.value = true;
    try {
      for (let i = 0; i < listesSelected.value.length; i++) {
        await addListeDeCourseToPanier(listesSelected.value[i].id);
        trackEvent({
          actionGA: trackingCodes.ACTIONGA.cartAttachement,
          categoryGA: trackingCodes.SHOPPINGLIST,
          labelGA: ''
        });
      }
    } finally {
      listesSelected.value = [];
      isLoading.value = false;
    }
  }
  const mounted = () => {
    setStoreLocatorContext('liste des courses')
  }

  return {
    isLoading,
    listeSelected,
    listesSelected,
    listesToDelete,
    createListeError,
    createListeState,
    toggleSelectList,
    isSelected,
    selectAll,
    unselectAll,
    deleteListes,
    deleteListe,
    confirmDeleteListes,
    openCreateListe,
    createListe,
    addToCartListe,
    confirmAddToCartListe,
    addToCartListes,
    mounted
  }

}
